export default class OptionsError extends Error {
    constructor(params: any) {
        super(params);
        this.name = 'OptionsError';
    }
}
